import React from "react";
import ReactDOM from "react-dom";
import _, { isFunction } from "underscore";
import { clearSurvey, closeSurvey, loadSurvey, reopenSurvey, setSurveyRating, setSurveyRatingNotes, addRatingPhotos, deleteRatingPhotos, getSurveyUsers } from "../../../actions/surveys";
import { isEmpty, isNotEmpty } from "../../../framework/utils";
import { getDefaultState, SurveysStore } from "../../../stores/surveys";
import M from "../../../strings";
import { connect } from "../../../utils/aj-react";
import { format, optional } from "../../../utils/lang";
import { ACTION_TYPES } from "../../components/mobile/actions";
import MobileLayout from "../../components/mobile/layout";
import ProgressBar from "../../components/mobile/progressBar";
import Secure from "../../components/secure";
import * as ui from "../../utils/ui";
import * as SurveyUtils from "../../utils/surveys";
import * as RetailersUtils from "../../utils/retailers";
import * as CustomUtils from "../../../utils/customUtils";
import { SURVEY_STATUS } from "../../../model/vars";
import { MaterialIcon } from "../../components/materialIcon";
import QuestionControl from "../../components/mobile/questions";
import DialogStore from "../../../stores/dialog";
import { mobileConfirm } from "../../../plugins";
import GradedValue, { gradedComponent, GRADE_TYPES } from "../../components/mobile/gradedValue";
import { showDialog } from "../../../actions/dialog";
import SurveySlideshowDownloadDialog from "./surveySlideshowDownloadDialog";

const USERS_POLLING_TIME = 30 * 1000;
const SCROLLER_THROTTLING_TIME = 50;
const SCROLLER_DEBOUNCING_TIME = 50;

export default class SurveyForm extends React.Component {
    constructor(props) {
        super(props);
        connect(this, SurveysStore, _.extend(getDefaultState(), {selectedAreaId: undefined}));
    }

    componentDidMount() {
        DialogStore.subscribe(this, state => {
            this.setState({
                dialogOpen: !state.hidden,
            });
        })

        const documentTitle = document.title,
            locationHref = location.href;

        this.onGoBack = () => {
            const $me = $(ReactDOM.findDOMNode(this)),
                $mobileDetector = $me.find(".mobile-detector"),
                selectedAreaId = this.state.selectedAreaId;
            if (isNotEmpty(selectedAreaId) && $mobileDetector.css("display") !== "none" && !this.state.dialogOpen) {
                history.pushState(null, documentTitle, locationHref);
                this.unselectArea();
            }
        }

        window.addEventListener("popstate", this.onGoBack)

        const surveyId = this.props.surveyId;
        loadSurvey({id: surveyId});
        this.pollUsers();
    }

    componentWillUnmount() {
        DialogStore.unsubscribe(this);
        if (isNotEmpty(this.onGoBack)) {
            window.removeEventListener("popstate", this.onGoBack)
        }
        clearSurvey();
        try {
            clearTimeout(this.usersPollingTimeout);
        } catch(e) {}
    }

    pollUsers() {
        this.usersPollingTimeout = setTimeout(() => {
            getSurveyUsers({id: this.props.surveyId});
            this.pollUsers();
        }, USERS_POLLING_TIME)
    }

    selectArea(id) {
        this.setState({selectedAreaId: id});
    }

    unselectArea() {
        this.setState({selectedAreaId: undefined});
    }

    getLeftActions() {
        return [
            {
                id: "backHomeMobile",
                type: ACTION_TYPES.ICON,
                icon: "arrow_back",
                className: "hidden-sm-up",
                rounded: true,
                onClick: () => {
                    const selectedAreaId = this.state.selectedAreaId;
                    if (isEmpty(selectedAreaId)) {
                        //ui.navigate("");
                        ui.back();
                    } else {
                        this.unselectArea();
                    }
                },
            },
            {
                id: "backHomeTablet",
                type: ACTION_TYPES.ICON,
                icon: "arrow_back",
                className: "hidden-xs-down",
                rounded: true,
                onClick: () => {
                    ui.back();
                    //ui.navigate("")
                },
            },
        ];
    }

    getRightActions() {
        const hasSelection = isNotEmpty(this.state.selectedAreaId),
            surveyData = optional(this.state.currentSurvey, {}),
            survey = optional(surveyData.survey, {}),
            status = survey.status,
            isOpen = status === SURVEY_STATUS.OPEN,
            actions = [];

        if (isOpen) {
            actions.push({
                id: "finishTablet",
                type: ACTION_TYPES.BUTTON,
                text: M("finish"),
                className: "hidden-xs-down btn-primary",
                onClick: () => this.closeSurvey(),
            });

            if (hasSelection) {
                actions.push({
                    id: "finishMobile",
                    type: ACTION_TYPES.BUTTON,
                    text: M("finish"),
                    className: "hidden-sm-up btn-primary",
                    onClick: () => this.closeSurvey(),
                });
            }
        } else {
            actions.push({
                id: "reopenTablet",
                type: ACTION_TYPES.BUTTON,
                text: M("reopen"),
                className: "hidden-xs-down btn-primary",
                onClick: () => this.reopenSurvey(),
            });

            if (hasSelection) {
                actions.push({
                    id: "reopenMobile",
                    type: ACTION_TYPES.BUTTON,
                    text: M("reopen"),
                    className: "hidden-sm-up btn-primary",
                    onClick: () => this.reopenSurvey(),
                });
            }

            actions.push({
                id: "downloadTablet",
                type: ACTION_TYPES.ICON,
                icon: "download",
                rounded: true,
                className: "hidden-xs-down",
                onClick: this.downloadReport.bind(this),
            });

            if (hasSelection) {
                actions.push({
                        id: "downloadMobile",
                        type: ACTION_TYPES.ICON,
                        icon: "download",
                        rounded: true,
                        className: "hidden-sm-up",
                        onClick: this.downloadReport.bind(this),
                    });
            }
        }
        
        return actions;
    }

    downloadReport() {
        showDialog({
            mobile: true,
            getContent: () => (<SurveySlideshowDownloadDialog
                    survey={this.state.currentSurvey?.survey}
                />)
        })
    }

    onRatingChange(data) {
        const surveyData = this.state.currentSurvey,
            survey = surveyData.survey,
            {input, questionId} = data;

            setSurveyRating({
                surveyId: survey.id,
                questionId: questionId,
                input: input,
            })
    }

    onSaveRatingNote(data) {
        const surveyData = this.state.currentSurvey,
            survey = surveyData.survey,
            {value, questionId} = data;

        setSurveyRatingNotes({
            surveyId: survey.id,
            questionId: questionId,
            notes: value || "",
        })
    }

    onSaveRatingPictures(data) {
        const surveyData = this.state.currentSurvey,
            survey = surveyData.survey,
            {questionId, pictures} = data;

        addRatingPhotos({
            surveyId: survey.id,
            questionId: questionId,
            pictures: pictures,
        })
    }

    onDeleteRatingPictures(data) {
        const surveyData = this.state.currentSurvey,
            survey = surveyData.survey;

        deleteRatingPhotos(_.extend(
            {surveyId: survey.id},
            data,
        ))
    }

    closeSurvey() {
        const surveyData = this.state.currentSurvey,
            survey = surveyData.survey;

        mobileConfirm(M("closeSurveyConfirmTitle"), M("closeSurveyConfirmMessage"))
            .then(() => closeSurvey({id: survey.id}));
    }

    reopenSurvey() {
        const surveyData = this.state.currentSurvey,
            survey = surveyData.survey;

        mobileConfirm(M("reopenSurveyConfirmTitle"), M("reopenSurveyConfirmMessage"))
            .then(() => reopenSurvey({id: survey.id}));
    }

    render() {
        const leftActions = this.getLeftActions(),
            rightActions = this.getRightActions(),
            currentSurvey = optional(this.state.currentSurvey, {}),
            hasSurvey = isNotEmpty(currentSurvey) && isNotEmpty(_.values(currentSurvey)),
            roots = optional(() => currentSurvey.roots, []),
            areas = _.chain(roots).pluck("children").flatten(1).value(),
            selectedAreaId = this.state.selectedAreaId,
            selectedArea = _.find(areas, a => a.category.id === selectedAreaId);

        return (
            <Secure>
                <MobileLayout
                    title={(<div className="hidden-xs-down">{optional(() => RetailersUtils.getStoreDescription(currentSurvey.store))}</div>)}
                    leftActions={leftActions}
                    rightActions={rightActions}
                >
                    <div
                        className="mobile-detector hidden-sm-up"
                    />
                    {hasSurvey && (<div
                        className="survey-form"
                    >
                        <Categories
                            surveyData={currentSurvey}
                            selectedArea={selectedArea}
                            onSelectArea={this.selectArea.bind(this)}
                        />
                        <Questions
                            key={selectedAreaId || "empty"}
                            surveyData={currentSurvey}
                            selectedArea={selectedArea}
                            onChange={this.onRatingChange.bind(this)}
                            onSaveNote={this.onSaveRatingNote.bind(this)}
                            onSavePictures={this.onSaveRatingPictures.bind(this)}
                            onDeletePictures={this.onDeleteRatingPictures.bind(this)}
                        />
                    </div>)}
                </MobileLayout>
            </Secure>
        )
    }
}

class Categories extends React.Component {

    onSelectArea(id) {
        if (this.props.onSelectArea && isFunction(this.props.onSelectArea)) {
            this.props.onSelectArea(id);
        }
    }

    render() {
        const surveyData = optional(this.props.surveyData, {}),
            survey = optional(surveyData.survey, {}),
            lastScore = optional(survey.lastScore,{}),
            surveyDescription = optional(() => survey.surveyTemplate.description),
            store = optional(surveyData.store, {}),
            roots = optional(surveyData.roots, []),
            score = SurveyUtils.getScoreValue(lastScore),//_.isFinite(lastScore.value) ? lastScore.value : 0,
            surveyProgress = _.isFinite(lastScore.progress) ? lastScore.progress : 0,
            totalQuestions = _.isFinite(lastScore.totalQuestions) ? lastScore.totalQuestions : 0,
            answeredQuestions = _.isFinite(lastScore.answeredQuestions) ? lastScore.answeredQuestions : 0,
            users = _.map(optional(surveyData.users, []), u => {
                    const user = optional(u.user, {}),
                        {name, lastname} = user;
                    let string = [];
                    
                    if (isNotEmpty(name)) {
                        string.push(name[0] + ".");
                    }

                    if (isNotEmpty(lastname)) {
                        string.push(lastname)
                    }
                    
                    return string.join(" ");
                }).join(", "),
            selectedAreaId = optional(() => this.props.selectedArea.category.id, undefined);

        return (
            <div
                className={"survey-form__categories" + (isEmpty(selectedAreaId) ? " show" : "")}
            >
                <div className="survey-summary">
                    <div
                        className="survey-summary__status"
                    >
                        <GradedValue
                            className="survey-summary__score"
                            value={score}
                            gradeType={GRADE_TYPES.SCORE}
                        />
                        <div
                            className="survey-summary__text"
                        >
                            {survey.status === SURVEY_STATUS.OPEN ? M("ongoing") : M("closed")}
                        </div>
                    </div>
                    <div
                        className="survey-summary__info"
                    >
                        <div
                            className="survey-summary__header"
                        >
                            {RetailersUtils.getStoreDescription(store, true)}
                        </div>
                        <div
                            className="survey-summary__progress"
                        >
                            <div
                                className="survey-summary__text"
                            >
                                {format(M("surveyProgressStatus"), answeredQuestions, totalQuestions)}
                            </div>
                            <ProgressBar
                                value={surveyProgress}
                            />
                        </div>
                        
                        <div
                            className="survey-summary__text"
                        >
                            {RetailersUtils.formatStoreAddress(store)}
                        </div>
                        <div
                            className="survey-summary__text"
                        >
                            {M("code")}: {survey.code}
                        </div>
                        <div
                            className="survey-summary__text"
                        >
                            {surveyDescription}
                        </div>
                        <div
                            className="survey-summary__text text-capitalize"
                        >
                            {users}
                        </div>
                    </div>
                </div>
                <div
                    className="categories__macroareas"
                >
                    {_.map(roots, r => {
                        const category = optional(r.category, {}),
                            key = category.id,
                            score = optional(category.score, {}),
                            areas = optional(r.children, []);

                        return (<div
                            key={key}
                            className="categories__macroarea"
                        >
                            <div
                                className="categories__macroarea-header"
                            >
                                <div
                                    className="categories__macroarea-title"
                                >
                                    {category.description}
                                </div>
                                <GradedValue
                                    className="pill-grade"
                                    gradeType={GRADE_TYPES.SCORE}
                                    value={optional(() => SurveyUtils.getScoreValue(score), 0)}
                                />
                            </div>
                            <div
                                className="categories__areas"
                            >
                                {_.map(areas, a => {
                                    const category = optional(a.category, {}),
                                        key = category.id,
                                        score = optional(category.score, {}),
                                        isActive = category.id === selectedAreaId;

                                    return (<div
                                            key={key}
                                            className={"categories__area" + (isActive ? " categories__area--active" : "")}
                                            onClick={() => this.onSelectArea(a.category.id)}
                                        >
                                            <div
                                                className="categories__area-score"
                                            >
                                                <GradedValue
                                                    className="pill-grade pill-grade--lg"
                                                    gradeType={GRADE_TYPES.SCORE}
                                                    value={optional(() => SurveyUtils.getScoreValue(score), 0)}
                                                />
                                            </div>
                                            <div
                                                className="categories__area-info"
                                            >
                                                <div
                                                    className="categories__area-title"
                                                >
                                                    {category.description}
                                                </div>
                                                <ProgressBar
                                                    value={score.progress || 0}
                                                />
                                            </div>
                                        </div>)
                                })}
                            </div>
                        </div>)
                    })}
                </div>
            </div>
        )
    }
}

class Questions extends React.Component {

    constructor(props) {
        super(props);

        this.bodyRef = React.createRef();
        this.questionsRef = React.createRef();
        this.scollerRef = React.createRef();

        this.state = {
            visibleQuestions: [],
        }

        this.onQuestionsBodyScroll = _.throttle(this._onQuestionsBodyScroll.bind(this), SCROLLER_THROTTLING_TIME);
        this.moveScroller = _.debounce(this._moveScroller, SCROLLER_DEBOUNCING_TIME);
    }

    componentDidMount() {
        this.updateVisibleQuestions();
    }

    getVisibleQuestions() {
        const hasSelection = isNotEmpty(this.props.selectedArea);

        if (!hasSelection) {
            return [];
        }

        const selectedArea = optional(this.props.selectedArea, {}),
            visibleItems = [],
            $questionsBody = $(ReactDOM.findDOMNode(this.bodyRef.current)),
            $questionList = $(ReactDOM.findDOMNode(this.questionsRef.current)),
            hasFullyVisibleQuestion = isNotEmpty(
                _.filter(
                        $questionsBody.find("[data-id]"),
                        q => CustomUtils.isInElement(q, $questionsBody.get(0), true)
                    )
                );

        _.each(selectedArea.children, c => {
            const isQuestionVisible = (id) => {
                        const $q = $questionList.find("[data-id=" + id + "]");
                        if (hasFullyVisibleQuestion && isEmpty(visibleItems)) {
                            return CustomUtils.isInElement($q.get(0), $questionsBody.get(0), true);
                        } else {
                            return CustomUtils.isInElement($q.get(0), $questionsBody.get(0), false);
                        }
                    };

            _.each(optional(c.questions, []), (q, index) => {
                let visible;
                const relatedQuestions = _.map(optional(q.relatedQuestions, []), rq => {
                    return {
                        id: rq.id,
                        visible: isQuestionVisible(rq.id),
                    }
                });

                if (isNotEmpty(relatedQuestions) && _.every(relatedQuestions, rq => rq.visible)) {
                    visible = true;
                } else {
                    visible = isQuestionVisible(q.question.id);
                }

                if (index === 0 && visible && isQuestionVisible(c.category.id)) {
                    visibleItems.push(c.category.id);
                }
                if (visible) {
                    visibleItems.push(q.question.id);
                }
                
                visibleItems.push(..._.chain(relatedQuestions).where({visible: true}).pluck("id").value());
            });
        });

        return visibleItems;
    }

    updateVisibleQuestions() {
        const visibleQuestions = this.getVisibleQuestions();
        return new Promise((resolve, reject) => {
            this.setState(
                    {
                        visibleQuestions: visibleQuestions,
                    },
                    () => resolve(visibleQuestions)
                );
        });
    }

    _onQuestionsBodyScroll() {
        this.updateVisibleQuestions()
            .then(visibleQuestions => {
                if (isEmpty(visibleQuestions)) {
                    return;
                }
                    
                const $scroller = $(ReactDOM.findDOMNode(this.scollerRef.current)),
                    currentScroll = $scroller.scrollTop(),
                    $firstItem = $scroller.find("[data-id=" + _.first(visibleQuestions) + "]"),
                    $lastItem = $scroller.find("[data-id=" + _.last(visibleQuestions) + "]"),
                    firstItemRect = $firstItem.get(0).getBoundingClientRect(),
                    lastItemRect = $lastItem.get(0).getBoundingClientRect(),
                    boundingRect = {
                            top: firstItemRect.top,
                            bottom: lastItemRect.bottom,
                            left: Math.min(firstItemRect.left, lastItemRect.left),
                            right: Math.max(firstItemRect.right, lastItemRect.right),
                            height: lastItemRect.bottom - firstItemRect.top,
                            width: Math.max(firstItemRect.right, lastItemRect.right) - Math.min(firstItemRect.left, lastItemRect.left),
                        },
                    parentRect = ReactDOM.findDOMNode(this.bodyRef.current).getBoundingClientRect();

                let requiredScroll = currentScroll;

                if (boundingRect.top < parentRect.top) {
                    requiredScroll = currentScroll - parentRect.top + boundingRect.top - 8;
                } else if (boundingRect.bottom > parentRect.bottom) {
                    requiredScroll = currentScroll - parentRect.bottom + boundingRect.bottom + 8;
                }

                if (requiredScroll !== undefined) {
                    this.moveScroller(requiredScroll);
                }
            })
    }

    _moveScroller(requiredScroll) {
        const scroller = ReactDOM.findDOMNode(this.scollerRef.current);

        scroller.scroll({
            top: requiredScroll,
            left: 0,
            behavior: 'smooth'
        });
    }

    onScrollerItemClick(id) {
        const selectedArea = optional(this.props.selectedArea, {}),
            $questionList = $(ReactDOM.findDOMNode(this.questionsRef.current));

        _.each(selectedArea.children, c => {
            const category = c.category,
                $category = $questionList.find("[data-id=" + category.id + "]");

            let questionToShow;

            if (category.id === id) {
                questionToShow = _.first(c.questions);
            } else {
                questionToShow = _.find(c.questions, q => {
                    return q.question.id === id || _.contains(_.pluck(q.relatedQuestions, "id"), id);
                })
            }

            if (isNotEmpty(questionToShow)) {
                const currentScroll = $questionList.scrollTop(),
                    $question = $questionList.find("[data-id=" + questionToShow.question.id + "]"),
                    questionRect = $question.get(0).getBoundingClientRect(),
                    parentRect = ReactDOM.findDOMNode(this.bodyRef.current).getBoundingClientRect(),
                    requiredScroll = currentScroll - parentRect.top + questionRect.top - $category.outerHeight();

                $questionList.get(0).scroll({
                        top: requiredScroll,
                        left: 0,
                        behavior: 'smooth'
                    });
            }
        })
    }

    onChange(data) {
        if (this.props.onChange && _.isFunction(this.props.onChange)) {
            this.props.onChange(data);
        }
    }

    onSaveNote(data) {
        if (this.props.onSaveNote && _.isFunction(this.props.onSaveNote)) {
            this.props.onSaveNote(data);
        }
    }

    onSavePictures(data) {
        if (this.props.onSavePictures && _.isFunction(this.props.onSavePictures)) {
            this.props.onSavePictures(data);
        }
    }

    onDeletePictures(data) {
        if (this.props.onDeletePictures && _.isFunction(this.props.onDeletePictures)) {
            this.props.onDeletePictures(data);
        }
    }

    render() {
        const hasSelection = isNotEmpty(this.props.selectedArea),
            selectedArea = optional(this.props.selectedArea, {}),
            areaCategory = optional(selectedArea.category, {}),
            areaScore = optional(areaCategory.score, {}),
            surveyData = optional(this.props.surveyData, {}),
            visibleQuestions = optional(this.state.visibleQuestions, []);

        return (
            <>
            {hasSelection ? (
                <div
                    className="survey-form__questions show"
                >
                    <div
                        className="survey-form__questions-header"
                    >
                        <GradedValue
                            className="pill-grade pill-grade--sm"
                            gradeType={GRADE_TYPES.SCORE}
                            value={optional(() => SurveyUtils.getScoreValue(areaScore), 0)}
                        />
                        <div
                            className="survey-form__questions-title"
                        >
                            {areaCategory.description}
                        </div>
                    </div>
                    <div
                        ref={this.bodyRef}
                        className="survey-form__questions-body"
                    >
                        <QuestionsScroller
                            ref={this.scollerRef}
                            area={selectedArea}
                            visibleItems={visibleQuestions}
                            onItemClick={this.onScrollerItemClick.bind(this)}
                        />
                        <QuestionsBody
                            ref={this.questionsRef}
                            area={selectedArea}
                            surveyData={surveyData}
                            onScroll={this.onQuestionsBodyScroll.bind(this)}
                            onChange={this.onChange.bind(this)}
                            onSaveNote={this.onSaveNote.bind(this)}
                            onSavePictures={this.onSavePictures.bind(this)}
                            onDeletePictures={this.onDeletePictures.bind(this)}
                        />
                    </div>
                </div>
            ) : (
                <div
                    className="survey-form__questions survey-form__questions--no-selection"
                >
                    <MaterialIcon
                        icon="question_answer"
                    />
                    <div>
                        {M("beginSurveyMessage")}
                    </div>
                </div>
            )}
            </>
            
        )
    }
}

class QuestionsScroller extends React.Component {

    onItemClick(id) {
        if (this.props.onItemClick && _.isFunction(this.props.onItemClick)) {
            this.props.onItemClick(id);
        }
    }

    mapItem(item) {
        const isQuestion = isNotEmpty(item.template),
            id = item.id,
            gradeType = isQuestion ? GRADE_TYPES.RATING : GRADE_TYPES.SCORE,
            visibleItems = optional(this.props.visibleItems, []),
            isVisible = _.contains(visibleItems, id),
            value = isQuestion
                ? optional(() => item.rating.value, 0) //We're deliberately not using getRatingValue here as input and value
                : optional(() => SurveyUtils.getScoreValue(item.score), 0),
            Component = gradedComponent("div");

        let className = "questions-scroller__item";

        if (!isQuestion) {
            className += " questions-scroller__item--lg";
        }

        if (isVisible) {
            className += " questions-scroller__item--visible";
        }

        return (<Component
            key={"scroller-item-" + id}
            className={className}
            value={value}
            gradeType={gradeType}
            data-id={id}
            onClick={this.onItemClick.bind(this, id)}
        />)
    }

    getItems() {
        const area=optional(this.props.area, {}),
            categories=optional(area.children, []),
            items = [];

        _.each(categories, c => {
            const category = optional(c.category,{}),
                questions = optional(c.questions, []);

            items.push(this.mapItem(category));

            _.each(questions, q => {
                const question = optional(q.question, {}),
                    relatedQuestions = optional(q.relatedQuestions, []);

                items.push(this.mapItem(question));

                _.each(relatedQuestions, rq => {
                    items.push(this.mapItem(rq));
                })
            })
        });

        return items;
    }

    render() {
        const items= this.getItems();

        return(
            <div
                className="survey-form__questions-scroller"
            >
                <div
                    className="questions-scroller__items"
                >
                    {items}
                </div>
            </div>
        )
    }
}

class QuestionsBody extends React.Component {

    constructor(props) {
        super(props);
        this.listRef = React.createRef();
        this.onScroll = _.throttle(this._onScroll.bind(this), 100);
    }

    componentDidMount() {
        this.listRef.current.addEventListener("scroll", this.onScroll);
    }

    componentWillUnmount() {
        this.listRef.current.removeEventListener("scroll", this.onScroll);
    }

    _onScroll() {
        if (this.props.onScroll && _.isFunction(this.props.onScroll)) {
            this.props.onScroll();
        }
    }

    onChange(data) {
        if (this.props.onChange && _.isFunction(this.props.onChange)) {
            this.props.onChange(data);
        }
    }

    onSaveNote(data) {
        if (this.props.onSaveNote && _.isFunction(this.props.onSaveNote)) {
            this.props.onSaveNote(data);
        }
    }

    onSavePictures(data) {
        if (this.props.onSavePictures && _.isFunction(this.props.onSavePictures)) {
            this.props.onSavePictures(data);
        }
    }

    onDeletePictures(data) {
        if (this.props.onDeletePictures && _.isFunction(this.props.onDeletePictures)) {
            this.props.onDeletePictures(data);
        }
    }

    render() {
        const area=optional(this.props.area, {}),
            categories=optional(area.children, []),
            surveyData=optional(this.props.surveyData, {}),
            survey=optional(surveyData.survey, {}),
            status=survey.status;

        return(
            <div
                ref={this.listRef}
                className="survey-form__questions-list"
            >
                {_.map(categories, c => {
                    const category = optional(c.category, {}),
                        score = optional(category.score, {}),
                        grade = SurveyUtils.gradeScore(score.value),
                        questions = optional(c.questions, []);
                    return(
                        <div
                            key={"questions-list__item_category-" + category.id}
                        >
                            <div
                                data-id={category.id}
                                className="questions-list__category-header"
                            >
                                <GradedValue
                                    className="pill-grade pill-grade--sm"
                                    gradeType={GRADE_TYPES.SCORE}
                                    value={optional(() => SurveyUtils.getScoreValue(score), 0)}
                                />
                                <div
                                    className="questions-list__category-title"
                                >
                                    {category.description}
                                </div>
                            </div>
                            {_.map(questions, q => {
                                const question = q.question,
                                    disabled = status !== SURVEY_STATUS.OPEN;
                                return (
                                    <div
                                        key={"questions-list__item-" + question.id}
                                        className="questions-list__item"
                                    >
                                        <QuestionControl
                                            disabled={disabled}
                                            questionData={q}
                                            onChange={this.onChange.bind(this)}
                                            onSaveNote={this.onSaveNote.bind(this)}
                                            onSavePictures={this.onSavePictures.bind(this)}
                                            onDeletePictures={this.onDeletePictures.bind(this)}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        )
    }
}